import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logo.svg';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={logo} alt="Quick Flick" className="logo-image" />
          </Link>
        </div>
        <div className="header-actions">
          <Link to="/login" className="btn btn-primary">Sign In</Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 